import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  hero: {
    title: {
      de: 'Mehr Freiraum für dein Business',
      en: 'More freedom for your business'
    },
    subtitle: {
      de: 'mit digitaler Automatisierung',
      en: 'with digital automation'
    },
    description: {
      de: 'Weniger manuelle Arbeit. Mehr Effizienz. Bessere Entscheidungen.',
      en: 'Less manual work. More efficiency. Better decisions.'
    },
    details: {
      de: 'Stell dir vor, dein Team verbringt weniger Zeit mit Papierkram, Excel-Listen und manuellen Prozessen – und kann sich stattdessen auf das Wachstum deines Unternehmens konzentrieren. Wir entwickeln maßgeschneiderte Lösungen, optimieren deine Prozesse und vernetzen deine Systeme nahtlos damit diese Vorstellung zur Realität wird.',
      en: 'Imagine your team spending less time on paperwork, Excel lists, and manual processes – and instead focusing on growing your business. We develop customized solutions, optimize your processes, and seamlessly connect your systems to make this vision a reality.'
    },
    solutions: {
      de: 'Unsere Lösungen',
      en: 'Our solutions'
    },
    cta: {
      de: 'Gespräch vereinbaren',
      en: 'Schedule a call'
    }
  }
}); 